
import { useNavigate } from 'react-router';
import { useEffect } from 'react';

import { useGetAppContext } from '@/services/context/queries';

import { CompleteRegistration } from './components/complete-registration';
import { Welcome } from './components/welcome';

interface VerifyInviteClientProps {
  email: string;
  organizationName: string;
  organizationId: number;
  passwordResetToken: string | undefined;
  googleToken: string;
}

export function VerifyInvite({
  email,
  organizationName,
  organizationId,
  passwordResetToken,
  googleToken,
}: VerifyInviteClientProps) {
  const navigate = useNavigate();
  const { data: appContext, isLoading } = useGetAppContext();
  const user = appContext?.user;

  useEffect(() => {
    if (isLoading) return;
    if (user && user.email !== email) {
      navigate('/logout', { replace: true });
    }
  }, [isLoading, user, email, navigate]);

  if (passwordResetToken) {
    return (
      <CompleteRegistration
        email={email}
        token={passwordResetToken}
        organizationId={organizationId}
        organizationName={organizationName}
        googleToken={googleToken}
      />
    );
  }

  return <Welcome organizationName={organizationName} user={user} />;
}
